import request from '@/utils/request';

/** 充值选项类接口：偏慢，单独放宽超时（默认 request 10s） */
const DEPOSIT_OPTIONS_TIMEOUT_MS = 30000;

/**
 * 查询充值选项（fiats / cryptos / countries）
 * GET /liyuan-evm-pm/pm-chain/alchemy/onramp/supported/options
 */
export function getSupportedFiats() {
  return request.get(
    '/liyuan-evm-pm/pm-chain/alchemy/onramp/supported/options',
    undefined,
    { timeout: DEPOSIT_OPTIONS_TIMEOUT_MS }
  );
}

/** 进入现金入金页上报一次查看 POST /liyuan-evm-pm/pm-chain/fiat/onramp/viewed */
export function reportFiatOnrampViewed() {
  return request.post('/liyuan-evm-pm/pm-chain/fiat/onramp/viewed', {});
}

/** 创建法币充值订单 POST /liyuan-evm-pm/pm-chain/alchemy/onramp/orders */
export function onrampOrder(data = {}) {
  return request.post('/liyuan-evm-pm/pm-chain/alchemy/onramp/orders', data);
}

/**
 * 分页查询法币充值订单
 * GET /liyuan-evm-pm/pm-chain/alchemy/onramp/orders
 * @param {{ pageNum?: number, pageSize?: number, status?: 'CREATED'|'PAY_SUCCESS'|'FINISHED'|'PAY_FAIL'|'EXPIRED' }} [params]
 */
export function getOnrampOrders(params = {}) {
  return request.get('/liyuan-evm-pm/pm-chain/alchemy/onramp/orders', params);
}

/**
 * 查询卖币选项（fiats / countries，与 onramp 同形时优先 fiats）
 * GET /liyuan-evm-pm/pm-chain/alchemy/offramp/supported/options
 */
export function getSupportedOptions() {
  return request.get('/liyuan-evm-pm/pm-chain/alchemy/offramp/supported/options');
}

/**
 * 创建法币提现订单
 * POST /liyuan-evm-pm/pm-chain/alchemy/offramp/orders
 * @param {{ country: string, cryptoAmount: number, fiat: string, language: string, redirectUrl: string }} data
 */
export function createOfframpOrder(data) {
  return request.post('/liyuan-evm-pm/pm-chain/alchemy/offramp/orders', data);
}

/** 创建法币提现订单 POST /liyuan-evm-pm/pm-chain/alchemy/offramp/orders */
export function offrampOrder(data = {}) {
  return request.post('/liyuan-evm-pm/pm-chain/alchemy/offramp/orders', data);
}
